
import Vue from "vue";
import Component from "vue-class-component";
import {
    EducationalQualificationRecordDetailsModel,
    QualificationRecordsClient,
} from "../../../../../api-client";
import { Prop } from "vue-property-decorator";
import Files from "@/components/Files.vue";

@Component({
    components: {
        Files,
    },
})
export default class EducationalQualificationRecordDetails extends Vue {
    @Prop()
    details!: EducationalQualificationRecordDetailsModel;

    navigateToEdit() {
        this.$router.push({
            name: "educationalRecordAdd",
            params: { id: this.details.id ?? "" },
        });
    }

    async getDownloadUrl(fileId: string): Promise<string> {
        return (
            await new QualificationRecordsClient().downloadEducationalRecordFile(
                this.$route.params.id,
                fileId
            )
        ).url;
    }
}
